import { createSelector } from '@reduxjs/toolkit'
import { stageSizeSelector } from './stage_selectors.js'

// the position and size of the background
export const backgroundBoundsSelector = createSelector(stageSizeSelector, function (stageSize) {
  return stageSize
})
